<div *ngIf='dialogData.schedules!=null'>
    <div class="modal-header">
        <h4 class="modal-title">{{dialogData.employeeName}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="container">
            <div class="table-responsive">
                <table class="table table-hover table-striped table-bordered mb-2">
                    <thead class="thead-light">
                        <tr>
                            <th scope="col">RES ID</th>
                            <th scope="col">Start Time</th>
                            <th scope="col">End Time</th>
                            <th scope="col">Weekly cap</th>
                            <th scope="col">Daily cap</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font-weight-bold">{{dialogData.resId}}</td>
                            <td> {{getFormatedDate(dialogData.schedules.resStartTime)}}</td>
                            <td> {{getFormatedDate(dialogData.schedules.resEndTime)}}</td>
                            <td>
                                <span *ngIf="dialogData.w_accepted >= dialogData.weekly_cap"
                                    class="badge-neutral-danger px-3 text-danger font-weight-bold">{{dialogData.w_accepted}}</span>
                                <span *ngIf="dialogData.w_accepted < dialogData.weekly_cap"
                                    class="badge-neutral-success px-3  text-success font-weight-bold">{{dialogData.w_accepted}}</span>
                                &nbsp;&nbsp;
                                <span
                                    class="badge-neutral-primary px-3 text-primary font-weight-bold">{{dialogData.weekly_cap}}</span>
                            </td>
                            <td>
                                <span *ngIf="dialogData.d_accepted >= dialogData.daily_cap"
                                    class="badge-neutral-danger px-3 text-danger font-weight-bold">{{dialogData.d_accepted}}</span>
                                <span *ngIf="dialogData.d_accepted < dialogData.daily_cap"
                                    class="badge-neutral-success px-3  text-success font-weight-bold">{{dialogData.d_accepted}}</span>
                                &nbsp;&nbsp;
                                <span
                                    class="badge-neutral-primary px-3 text-primary font-weight-bold">{{dialogData.daily_cap}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!--  <div class="col-xl-12"> -->
            <!-- <div class="row no-gutters">
                <div class="col-lg-6 text-center">
                    <span class="opacity-6 pb-2">Greet Start Time </span>
                    <div class="d-flex align-items-center justify-content-center">
                        <span class="font-weight-bold ">
                            {{getFormatedDate(dialogData.schedules.resStartTime)}}
                        </span>
                    </div>
                </div>
                <div class="col-lg-6 text-center ">
                    <span class="opacity-6 pb-2">Greet End Time</span>
                    <div class="d-flex align-items-center justify-content-center">
                        <span class="font-weight-bold ">
                            {{getFormatedDate(dialogData.schedules.resEndTime)}}

                        </span>
                    </div>
                </div>
            </div> -->
            <div class="divider my-2"></div>

            <div class="table-responsive">
                <table class="table table-hover text-nowrap table-borderless mb-0"
                    *ngIf="dialogData.schedules.slots.length!=0">
                    <tbody>
                        <tr *ngFor="let slot of dialogData.schedules.slots">
                            <td>
                                <div class="text-left font-size-lg" *ngIf="!slot.isAvailable">
                                    <small class="text-black-50 d-block">Accepted</small>
                                    <span class="text-danger  display-4 font-weight-bold font-size-lg">
                                        {{slot.accepted}}
                                    </span>
                                </div>
                                <div class="text-left font-size-lg" *ngIf="slot.isAvailable">
                                    <small class="text-black-50 d-block">Accepted</small>
                                    <span class="text-success display-4 font-weight-bold font-size-lg">
                                        {{slot.accepted}}
                                    </span>
                                </div>
                                <div class="text-left font-size-lg" *ngIf="status=='Accepted'">
                                    <small class="text-black-50 d-block">Accepted</small>
                                    <span class="display-4 text-info font-weight-bold font-size-lg">
                                        {{slot.accepted}}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <alert type="danger" *ngIf="!slot.isAvailable">
                                    <div class="margin-css d-flex align-items-center align-content-center">
                                        <!-- <span class="font-size-lg d-block d-40 mr-3 text-center bg-white-50 rounded-sm">
                                                      <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                                                  </span> -->
                                        <span>
                                            <strong class="d-block">Not Available</strong>
                                            {{getFormatedDate(slot.startTime)}}
                                            <b>-</b> {{getFormatedDate(slot.endTime)}}
                                        </span>
                                    </div>
                                </alert>

                                <alert type="success" *ngIf="slot.isAvailable">
                                    <div class="margin-css d-flex align-items-center align-content-center">
                                        <span>
                                            <strong class="d-block">Available!</strong>
                                            {{getFormatedDate(slot.startTime)}}
                                            <b>-</b> {{getFormatedDate(slot.endTime)}}
                                        </span>
                                    </div>
                                </alert>

                                <alert type="info" *ngIf="status=='Accepted'">
                                    <div class="margin-css d-flex align-items-center align-content-center">
                                        <span>
                                            <strong class="d-block">Assigned!</strong>
                                            {{getFormatedDate(slot.startTime)}}
                                            <b>-</b> {{getFormatedDate(slot.endTime)}}
                                        </span>
                                    </div>
                                </alert>
                            </td>
                            <td>
                                <!-- <button type="button" class="btn btn-primary ml-auto"
                                    [disabled]='isGreetAssignedFromWeb' (click)="assin(slot)">Assign</button> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-hover text-nowrap table-borderless mb-0"
                    *ngIf="dialogData.schedules.slots.length==0">
                    <tbody>
                        <tr>
                            <td>
                                <span class="font-weight-bold ">
                                    No slots available for this reservation time
                                </span>
                            </td>
                            <td>
                                <!-- <button type="button" class="btn btn-primary ml-auto"
                                    [disabled]='isGreetAssignedFromWeb' (click)="assin(null)">Assign</button> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>
<div *ngIf='dialogData.schedules==null'>
    <div class="modal-header">
        <h4 class="modal-title">{{dialogData.message}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div>

<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>